import SubjectAreaResourceListResultModel from '../../generated/types/model/resource/SubjectAreaResourceListResultModel';

export default class SubjectAreaResourceListResultViewModel extends SubjectAreaResourceListResultModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
